import { render } from "./SwitchForm.vue?vue&type=template&id=58c71bcd&ts=true"
import script from "./SwitchForm.vue?vue&type=script&lang=ts"
export * from "./SwitchForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SwitchForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58c71bcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58c71bcd', __exports__)) {
    api.reload('58c71bcd', __exports__)
  }
  
  module.hot.accept("./SwitchForm.vue?vue&type=template&id=58c71bcd&ts=true", () => {
    api.rerender('58c71bcd', render)
  })

}


export default __exports__